/**
 * Minimal pub/sub so systems (combat, spawning, progression, ui, audio) can
 * react to game events without holding direct references to each other.
 * e.g. combat emits 'boss:damaged', ui listens for 'boss:damaged' to update
 * the health bar, audio listens for 'boss:damaged' to play a hit sfx.
 */
export class EventBus {
  constructor() {
    this._listeners = new Map();
  }

  on(event, handler) {
    if (!this._listeners.has(event)) this._listeners.set(event, new Set());
    this._listeners.get(event).add(handler);
    return () => this.off(event, handler);
  }

  off(event, handler) {
    this._listeners.get(event)?.delete(handler);
  }

  emit(event, payload) {
    const handlers = this._listeners.get(event);
    if (!handlers) return;
    // Copy to array — handlers may add/remove listeners mid-emit.
    for (const handler of [...handlers]) handler(payload);
  }
}
